import { faGoogle, faMicrosoft } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FlatButton } from '@framework/ui/atoms';
import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

type Props = {
  onLoginWithGoogle(): void;
  onLoginWithMicrosoft?(): void;
  onLoginWithEmail(): void;
};

export const LoginMethodMenu: React.FC<Props> = ({
  onLoginWithGoogle,
  onLoginWithMicrosoft,
  onLoginWithEmail,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex w-80 flex-col space-y-4 px-5 py-2">
      <FlatButton color="brand" onClick={onLoginWithGoogle}>
        <span className="pr-2 text-lg">
          <FontAwesomeIcon icon={faGoogle} />
        </span>
        {t('auth.login.loginWithGoogle')}
      </FlatButton>

      {onLoginWithMicrosoft && (
        <FlatButton color="brand" onClick={onLoginWithMicrosoft}>
          <span className="pr-2 text-lg">
            <FontAwesomeIcon icon={faMicrosoft} />
          </span>
          {t('auth.login.loginWithMicrosoft')}
        </FlatButton>
      )}

      <FlatButton color="brand" onClick={onLoginWithEmail}>
        {t('auth.login.loginWithEmail')}
      </FlatButton>

      <div className="text-center">
        <div>
          <Link to={UserPagePathBuilder.passwordResetPage()} className="text-sm text-blue-700 hover:underline">
            {t('auth.login.forgotPassword')}
          </Link>
        </div>
        <div>
          <Link to={UserPagePathBuilder.entryPage()} className="text-sm text-blue-700 hover:underline">
            {t('auth.login.signUp')}
          </Link>
        </div>
      </div>
    </div>
  );
};
